const ProductFeature = Object.freeze({
  SEARCHES: 'searches',
  AI_RESPONSES: 'ai_responses',
  EXTRA_SEARCHES: 'extra_searches',
  EXTRA_AI_RESPONSES: 'extra_ai_responses',
} as const);

export type ProductFeature = (typeof ProductFeature)[keyof typeof ProductFeature];

export const AvailableProductFeatures = Object.entries(ProductFeature).map(([, value]) => value);

export default ProductFeature;
